<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-header">
        <h3>{{ ContactId ? 'Edit' : 'Add' }} Contact</h3>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="cancel()"
        ></button>
      </div>
      <div class="modal-body">
        @if (contactForm) {
          <form [formGroup]="contactForm">
            <div class="row">
              <div class="col-6">
                <label for="firstName" class="form-label"
                  >First Name<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  formControlName="firstName"
                />
              </div>
              <div class="col-6">
                <label for="lastName" class="form-label"
                  >Last Name<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="lastName"
                  formControlName="lastName"
                />
              </div>
              <div class="col-6">
                <label for="email" class="form-label"
                  >Email<span class="required-field-asterisk">*</span></label
                >
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  formControlName="email"
                />
              </div>
              <div class="col-6">
                <label for="isPrimary" class="form-label"
                  >isPrimary?
                  <span class="required-field-asterisk">*</span></label
                >
                <select
                  class="form-select"
                  id="isPrimary"
                  formControlName="isPrimary"
                >
                  <option [ngValue]="true">YES</option>
                  <option [ngValue]="false">NO</option>
                </select>
              </div>
              <div class="col-12">
                <label for="phone1" class="form-label"
                  >Phone<span class="required-field-asterisk">*</span></label
                >
                <input
                  type="tel"
                  class="form-control"
                  id="phone1"
                  formControlName="phone1"
                />
              </div>
            </div>
            <div class="row" formGroupName="StreetAddress">
              <div class="col-12">
                <label for="address1" class="form-label"
                  >Address<span class="required-field-asterisk">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="address1"
                  formControlName="address1"
                />
              </div>
              <div class="col-12">
                <label for="address2" class="form-label">Address 2</label>
                <input
                  type="text"
                  class="form-control"
                  id="address2"
                  formControlName="address2"
                />
              </div>
              <div class="col-4">
                <label for="city" class="form-label"
                  >City<span class="required-field-asterisk">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="city"
                  formControlName="city"
                />
              </div>
              <div class="col-4">
                <label for="state" class="form-label"
                  >State<span class="required-field-asterisk">*</span></label
                >
                <select class="form-select" id="state" formControlName="state">
                  @for (
                    SubNationalDivision of SubNationalDivisions;
                    track SubNationalDivision
                  ) {
                    <option [ngValue]="SubNationalDivision.abbreviation">
                      {{ SubNationalDivision.name }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-4">
                <label for="zip" class="form-label"
                  >Zip<span class="required-field-asterisk">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="zip"
                  formControlName="zip"
                />
              </div>
            </div>
          </form>
        }
      </div>
      <div class="modal-footer">
        <div class="col-2">
          <button type="button" class="btn btn-secondary" (click)="cancel()">
            Cancel
          </button>
        </div>
        <div class="col-2">
          <button type="button" class="btn btn-primary" (click)="saveContact()">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
